import React from 'react'
import './contact.css'
import {MdOutlineEmail} from 'react-icons/md'
import {BsWhatsapp} from 'react-icons/bs'
import { useRef } from 'react';
import emailjs from 'emailjs-com';


const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_1gkrekc', 'template_06htr5k', form.current, 'rl7tnHYM1hNDEIB--')
    e.target.reset()
  };

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className='container contact_container'>
        <div className='contact_options'>
          <article className='contact_option'>
            <MdOutlineEmail className='contact_icon'/>
            <h4>Email</h4>
            <h5>ahmadalamgirwork@gmail.com</h5>
            <a href="mailto:ahmadalamgirwork@gmail.com" target='_blank'>Send Email</a>
          </article>
          <article className='contact_option'>
            <BsWhatsapp className='contact_icon'/>
            <h4>WhatsApp</h4>
            <a href="https://wa.me/923154553399" target='_blank'>Send Message</a>
          </article>
        </div>
      </div>        
    </section>
  )
}

export default Contact